<template>
  <div class="auditCashierContainer">
    <section class="dialogsBox" v-show="auditIsShow">
      <div>
        <h3>
          批量出/入帐
          <h4>{{ "已选中" + ids.length + "条费用" }}</h4>
        </h3>
        <a @click="rejectCancel" class="close">
          <a-icon type="close-circle" style="font-size: 30px; color: #333" />
        </a>
        <ul>
          <li>
            <label><i>*</i>出/入帐日期：</label>
            <p>{{ flow_date }}</p>
          </li>
          <li>
            <label><i>*</i>出/入帐账户：</label>
            <a-select v-model="company_id" show-search style="width: 60%">
              <a-select-option
                v-for="item in companyList"
                :key="item.id"
                :value="item.id"
                >{{ item.company_name }}</a-select-option
              >
            </a-select>
          </li>
          <li>
            <label> <i>*</i>外包平台： </label>
            <a-radio-group v-model="is_platform">
              <a-radio :value="2">使用</a-radio>
              <a-radio :value="1">未使用</a-radio>
            </a-radio-group>
          </li>
          <li v-show="is_platform == 2">
            <label> <i>*</i>外包平台：</label>
            <a-select style="width: 120px" v-model="finance_platform_id">
              <a-select-option
                :value="element.id"
                v-for="(element, k) in platformList"
                :key="k"
              >
                {{ element.name }}
              </a-select-option>
            </a-select>
          </li>
          <li>
            <label><i>*</i>银行流水编号：</label>
            <a-input style="width:60%" v-model="bank_flow_num" />
          </li>
          <li>
            <label>备注：</label>
            <a-textarea v-model="remark" style="width: 80%" />
          </li>
        </ul>
        <div>
          <a-button type="primary" @click="batchSubmit">确定</a-button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      flow_date: moment(new Date()).format("YYYY-MM-DD"),
      company_id: "",
      companyList: [],
      ids: [],
      remark: "",
      auditIsShow: true,
      bank_flow_num: "",
      is_platform: 2,
      finance_platform_id: "",
      platformList: []
    };
  },
  mounted() {
    this.getCompany();
    if (this.batchCreditIds != undefined) {
      this.getIds();
    }
    this.getPlatform(); //获取外包平台
  },
  props: {
    batchCreditIds: Array
  },
  watch: {
    batchCreditIds() {
      this.getIds();
    }
  },
  methods: {
    getPlatform() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Finance_platform/lists";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 10000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.platformList = res.data.data.data;
            // console.log(this.platformList);
          }
        });
    },
    verify() {
      let fls = true;
      if (this.company_id == "") {
        fls = false;
        this.$message.warning("请输入账户");
        return fls;
      }
      if (this.bank_flow_num == "") {
        fls = false;
        this.$message.warning("请输入银行流水编号");
        return fls;
      }
      if (this.is_platform == 2 && this.finance_platform_id == "") {
        fls = false;
        this.$message.warning("请选择外包平台");
        return fls;
      }
      return fls;
    },
    batchSubmit() {
      let fls = this.verify();
      if (fls) {
        this.auditIsShow = false;
        this.auditPassHttp();
      }
    },
    auditPassHttp() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "finance/batchCashierCheckPass";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        ids: JSON.stringify(this.ids),
        flow_date: this.flow_date,
        company_id: this.company_id,
        remark: this.remark,
        bank_flow_num: this.bank_flow_num,
        is_platform: this.is_platform,
        finance_platform_id: this.finance_platform_id
      };
      if (this.is_platform == 1) {
        delete params.finance_platform_id;
      }
      axios.post(url, params).then(res => {
        this.auditIsShow = true;
        if (res.data.code == 200) {
          this.$emit("hideInDialogBatchCredit", true);
          this.$message.success("批量操作成功");
        } else {
          this.$emit("hideInDialogBatchCredit", false);
          this.$message.error(res.data.message);
        }
      });
    },
    getIds() {
      this.ids = this.batchCreditIds;
    },
    getCompany() {
      let url =
        this.httpsBasic.url + this.httpsBasic.customer + "Company/companyList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 100000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.companyList = res.data.data.data;
            // console.log(this.companyList);
          }
        });
    },
    rejectCancel() {
      this.$emit("hideInDialogBatchCredit", false);
    }
  }
};
</script>
<style lang="less" scoped>
.dialogsBox > div {
  margin-top: 100px;
  width: 600px;
  > ul {
    text-align: left;
    margin: 0 30px;
    li {
      margin-bottom: 20px;
      > label,
      > p,
      > span {
        line-height: 30px;
      }
    }
    .disStyle {
      display: inline-block;
      width: 50%;
      padding-right: 20px;
    }
  }
  h3 {
    h4 {
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #666;
      margin-top: 10px;
    }
  }
}
</style>
